/* NVZN3D TRUEVIEW AR JAVASCRIPT */

(function () {

  const nvznAppData = JSON.parse(document.getElementById('nvzn3d-trueview-data').textContent);
  if (!nvznAppData) return console.error('[NVZN] nvzn3d-trueview-data not found');
  log('nvzn3d-trueview-data:', nvznAppData);

  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
      return;
    }
    document.querySelectorAll('.nvzn3d-arbutton').forEach((button) => {
      button.addEventListener('click', function () {
        let options = {
          clientID: nvznAppData.app.clientID,
          width: nvznAppData.product.arDimensions.width,
          length: nvznAppData.product.arDimensions.length,
          units: nvznAppData.product.arDimensions.units,
          shape: nvznAppData.product.arDimensions.shape,
          imageUrl: nvznAppData.product.arImage,
        };
        log('options:', options);
        displayPreview(options);
      });
    });
  }

  function displayPreview(options) {
    Nvzn3D.displayFloorPreview({
      clientId: options.clientID,
      width: options.width,
      length: options.length,
      units: options.units,
      imageUrl: options.imageUrl,
    });
  }

  function log(...args) {
    if (nvznAppData.app && nvznAppData.app.logging) {
      console.log('[NVZN]', ...args);
    }
  }

  init();
})();
